module.exports = __webpack_public_path__ + "img/icon-06.ba46c474.svg";